import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { requestWeather } from '../../dataSource/weather/weather.request'
import { isDistrict, isTown } from '../../store/address/address.helpers'
import {
  selectFirstAddress,
  selectFirstAddressCoordinates,
  selectHasOnlyOneAddress
} from '../../store/address/address.selectors'
import { selectLocale } from '../../store/navigation/navigation.selectors'
import { useAbTestVariant } from '../abtest/useAbTest'
import { translate } from '../i18n/T'
import s from './Weather.less'
import atmosphereIcon from './icons/atmosphere.svg'
import clearIcon from './icons/clear.svg'
import cloudsIcon from './icons/clouds.svg'
import drizzleIcon from './icons/drizzle.svg'
import rainIcon from './icons/rain.svg'
import snowIcon from './icons/snow.svg'
import thunderstormIcon from './icons/thunderstorm.svg'
import { WEATHER_POLLUTION_AQI, WEATHER_SIMPLIFED_TYPES } from './weather.constants'

const getWeatherIconUrl = weatherType => {
  // icons from https://www.iconfinder.com/iconsets/weather-color-2
  switch (weatherType) {
    case WEATHER_SIMPLIFED_TYPES.Clear:
      return clearIcon
    case WEATHER_SIMPLIFED_TYPES.Clouds:
      return cloudsIcon
    case WEATHER_SIMPLIFED_TYPES.Rain:
      return rainIcon
    case WEATHER_SIMPLIFED_TYPES.Drizzle:
      return drizzleIcon
    case WEATHER_SIMPLIFED_TYPES.Thunderstorm:
      return thunderstormIcon
    case WEATHER_SIMPLIFED_TYPES.Snow:
      return snowIcon
    case WEATHER_SIMPLIFED_TYPES.Atmosphere:
      return atmosphereIcon
  }
}

// webpack:BrowserOnly
const Weather = () => {
  const abTest = useAbTestVariant('weather')
  const [weatherData, setWeatherData] = useState(null)
  const locale = useSelector(selectLocale)
  const t = translate(locale)
  const hasOnlyOneAddress = useSelector(selectHasOnlyOneAddress)
  const address = useSelector(selectFirstAddress)
  const firstAddressCoordinates = useSelector(selectFirstAddressCoordinates)

  const isAddressATownOrADistrict = isTown(address) || isDistrict(address)

  const candidate = abTest?.id === 'on' && hasOnlyOneAddress && isAddressATownOrADistrict

  useEffect(() => {
    setWeatherData(null)
    const fetchWeather = async (coords, locale) => {
      setWeatherData(await requestWeather(coords, locale))
    }
    if (candidate) fetchWeather(firstAddressCoordinates, locale)
  }, [candidate, firstAddressCoordinates, setWeatherData, locale])

  if (!weatherData) return <></>

  const { weatherType, description, temp, pollution_aqi } = weatherData ?? {}
  const weatherIconUrl = getWeatherIconUrl(weatherType)
  const pollutionColor = WEATHER_POLLUTION_AQI[pollution_aqi]

  return (
    <div className={s.root}>
      <div className={s.row}>
        {weatherIconUrl && <img src={weatherIconUrl} className={s.icon} alt={weatherType} title={description} />}
        <span className={s.temp}>{temp}°</span>
      </div>
      <div className={s.details}>
        {pollution_aqi && (
          <div className={s.row}>
            <span className={s.pollutionTitle}>{t('weather.pollution.title')}</span>
            <span
              className={s.pollutionQuality}
              style={{ backgroundColor: pollutionColor }}
              title={t(`weather.pollution.${pollution_aqi}`)}
            ></span>
          </div>
        )}
      </div>
    </div>
  )
}

export default Weather
